<div *ngIf="videoError" class="mt-2 txt-regular fs-12 text-danger">{{ videoError }}</div>
<div *ngIf="videoMeta" class="mt-20">
    <div *ngIf="videoMeta.type === 'file' && videoMeta.url && safeUrl">
        <video #videoPlayer width="100%" height="400" [src]="safeUrl" controls></video>
        <button (click)="pauseVideo()">Pause after 5s and toggle show</button>
        <button (click)="closebutton()">Close & Play</button>
    </div>
    <div *ngIf="videoMeta.type === 'youtube' && videoMeta.id && safeUrl">
        <ng-container *ngIf="!youtubeEmbedFailed">
            <iframe width="100%" height="400" [src]="safeUrl" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen referrerpolicy="strict-origin-when-cross-origin" (error)="onYouTubeEmbedError()">
            </iframe>
        </ng-container>
        <div *ngIf="youtubeEmbedFailed" class="mt-2 txt-regular fs-12 text-danger">
            This video cannot be embedded due to YouTube restrictions.<br>
            <a [href]="'https://www.youtube.com/watch?v=' + videoMeta.id" target="_blank">Watch on YouTube</a>
        </div>
    </div>
    <div *ngIf="videoMeta.type === 'vimeo' && videoMeta.id && safeUrl">
        <iframe width="100%" height="400" [src]="safeUrl" frameborder="0" allowfullscreen></iframe>
    </div>
</div>